interface DatePickerProps {
  value: number
  onChange: (newValue: any) => void
  label: string
  disabled?: boolean
}

const DatePicker = ({ value, onChange, label, disabled }: DatePickerProps) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '10px',
        }}
      >
        <label
          htmlFor="date"
          style={{
            fontWeight: 'bold',
            paddingBottom: '10px',
          }}
        >
          {label}
        </label>
        <input
          name="date"
          type="datetime-local"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        ></input>
      </div>
    </>
  )
}

export default DatePicker
